export enum MEDIA_SIZES {
  desktop = 992,
  tablet = 640,
  mobileBig = 460,
  main = 377,
  mobile = 320,
}
